import { z } from 'zod';

import {
  VULNERABILITY_ANNOTATION_ACTION_STATEMENT_MAX_LENGTH,
  VULNERABILITY_ANNOTATION_ACTION_STATEMENT_PATTERN,
  VULNERABILITY_ANNOTATION_ADDITIONAL_DETAILS_MAX_LENGTH,
  VULNERABILITY_ANNOTATION_ADDITIONAL_DETAILS_PATTERN,
  VULNERABILITY_ANNOTATION_IMPACT_STATEMENT_MAX_LENGTH,
  VULNERABILITY_ANNOTATION_IMPACT_STATEMENT_PATTERN,
  VULNERABILITY_ANNOTATION_STATUS_NOTES_MAX_LENGTH,
  VULNERABILITY_ANNOTATION_STATUS_NOTES_PATTERN,
} from '@models/autogen/v2.constraints';
import {
  VexJustification,
  VexStatus,
} from '@features/applications/applications.models';
import { MULTILINE_TEXT_PATTERN_MESSAGE } from '@features/applications/common/validation-messages';

const optionalText = (maxLength: number, pattern: RegExp) =>
  z
    .string()
    .max(maxLength, `Must be ${maxLength.toLocaleString()} characters or fewer`)
    .regex(pattern, MULTILINE_TEXT_PATTERN_MESSAGE)
    .nullable()
    .optional();

export const vulnerabilityAnnotationFormSchema = z.object({
  actionStatement: optionalText(
    VULNERABILITY_ANNOTATION_ACTION_STATEMENT_MAX_LENGTH,
    VULNERABILITY_ANNOTATION_ACTION_STATEMENT_PATTERN,
  ),
  additionalDetails: optionalText(
    VULNERABILITY_ANNOTATION_ADDITIONAL_DETAILS_MAX_LENGTH,
    VULNERABILITY_ANNOTATION_ADDITIONAL_DETAILS_PATTERN,
  ),
  impactStatement: optionalText(
    VULNERABILITY_ANNOTATION_IMPACT_STATEMENT_MAX_LENGTH,
    VULNERABILITY_ANNOTATION_IMPACT_STATEMENT_PATTERN,
  ),
  justification: z.enum(VexJustification).nullable().optional(),
  status: z.enum(VexStatus).nullable(),
  statusNotes: optionalText(
    VULNERABILITY_ANNOTATION_STATUS_NOTES_MAX_LENGTH,
    VULNERABILITY_ANNOTATION_STATUS_NOTES_PATTERN,
  ),
});

export type VulnerabilityAnnotationFormValues = z.infer<
  typeof vulnerabilityAnnotationFormSchema
>;

export const vulnerabilityAnnotationDefaultValues: VulnerabilityAnnotationFormValues =
  {
    actionStatement: '',
    additionalDetails: '',
    impactStatement: '',
    justification: null,
    status: null,
    statusNotes: '',
  };
